import { mask } from '../mask';
import normalizeNumber from '../normalize-number';

export default function applyNumberMask({ value, pattern }) {
  if (!value) {
    return '';
  }

  const valueFormated = normalizeNumber(value).trim();

  return mask(valueFormated, pattern);
}
